var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientLargerCardMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 245,
    viewBox: "0 0 276 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 156C42 154.895 42.8954 154 44 154H122V226H42V156Z",
    fill: "#F68500",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225.851 57.5565L45.6691 45.693C11.0765 44.9342 12.013 63.8 14.5891 75.8233C18.4017 87.2129 39.0367 112.568 91.0761 122.872C143.116 133.176 180.541 173.142 192.749 191.837C202.595 205.415 223.385 232.048 236.874 231.991C250.364 231.935 238.183 216.141 239.249 209.484L254.45 82.8073C253.273 66.7475 231.667 57.8309 225.851 57.5565Z",
    fill: "url(#paint0_linear_749_839)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_749_839",
    x1: 126.292,
    y1: 54.7075,
    x2: 269.954,
    y2: 178.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A00CD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientLargerCardMobile);
export default __webpack_public_path__ + "static/media/gradient-larger-card-mobile.5dd63fe6d791552586d313e02ff0163a.svg";
export { ForwardRef as ReactComponent };